/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview react-select style factory for EventCreation category dropdown.
 * @module utils/eventCreation/eventCreationCategorySelectStyles
 */

export const getEventCreationCategorySelectStyles = (showError, categoria) => ({
  control: (baseStyles) => ({
    ...baseStyles,
    borderRadius: "8px",
    width: "100%",
    height: "40px",
    fontSize: "16px",
    cursor: "pointer",
    textAlign: "left",
    borderColor: showError && !categoria ? "red" : "#909092",
  }),
  container: (baseStyles) => ({
    ...baseStyles,
    width: "100%",
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
  }),
  input: (baseStyles) => ({
    ...baseStyles,
  }),
  option: (baseStyles) => ({
    ...baseStyles,
    cursor: "pointer",
  }),
  indicatorSeparator: () => ({ display: "none" }),
});
